import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, vShow as _vShow, withKeys as _withKeys, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-76b4d745"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id", "draggable"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "strip-handle" }, null, -1))
const _hoisted_3 = { class: "strip-buttons" }
const _hoisted_4 = ["value"]
const _hoisted_5 = { class: "strip-n" }
const _hoisted_6 = { class: "mn-tag tag-person waiting" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-exclamation-octagon" }, null, -1))
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "menuheader" }
const _hoisted_12 = ["onClick"]

import sys from '@/sys';
import TicketTimingComponent from '@/components/Workspaces/todos/_spec/TicketTiming.vue'
import { PersonRmodel } from '@/app.context/workspace/person.rmodel';
import { TodoRmodel } from '@/app.context/workspace/tickets/todo.rmodel';
import { TicketRmodel } from '@/app.context/workspace/ticket.rmodel';
import { computed, reactive, ref } from '@vue/reactivity';
import { ticketInternal, dragDataSetup, onTicketItemDrage, onTicketItemDragEnd, cardClassOfStatus, personSubmenuController as PersonSubmenuController, tasks_ExceptCurrentPerson } from '@/controllers/workspaces/tickets/_spec/ticket.item.controller'
import { downloadTicketFile } from '@/controllers/workspaces/tickets/_spec/ticket.controller'

import { useAppContext } from '@/app/_tech';
import { TicketAccessLevel } from '@/controllers/workspaces/user.controller.workspace';
import { taskStatusCss } from '@/controllers/workspaces/tickets/task.controller'
import { item } from '@/app.context/workspace/tickets/_spec/Ticket.Item.Model'
import { block_impersonal, blockers_unresolved } from '@/controllers/workspaces/todo.controller';
import { clipboardTicketTitle } from '@/controllers/workspaces/tickets/_spec/ticket.controller'
import { BlockRmodel } from '@/app.context/workspace/tickets/tasks/block.rmodel';
import { TaskRmodel } from '@/app.context/workspace/tickets/task.rmodel';
import { TqueuePosition } from '@/logic/_infra/queues';
import { nextTick } from 'vue';
import { isTicket } from '@/controllers/workspaces/tickets/_model/ticket.item.controller';
import uiController, { emitDefinition, IEmits, IProps } from '@/components/Workspaces/tickets/_spec/ticket.controller.ui'
import { LabelModel } from '@/app.context/workspace/label.rmodel';
import { ITicketUiElementController } from './ticket.controller.elementary.interface';
import { SunriseReportRmodel } from '@/app.context/workspace/persons/sunrise.rmodel';


export default /*#__PURE__*/_defineComponent({
  __name: 'TicketStrip',
  props: {
    ticket: {},
    todo: {},
    level: {},
    circledX: { type: Boolean },
    controller: {},
    efforts: {}
  },
  emits: emitDefinition,
  setup(__props: any, { emit: __emit }) {

const context = useAppContext();

const props = __props

const emit = __emit



const triggers: IEmits =
{
    v: (...args:any[]) => emit("v", ...args),
    x: (...args:any[]) => emit("x",...args),
    o: (...args:any[]) => emit("o", ...args),
    block: function (b: BlockRmodel): void {
        emit("block", b)
    },
    files: function (f: boolean | File[]): void {
        emit("files", f)
    },
    click: function (...args: any[]): void {
        emit("click", ...args)
    },
    label: function (l: LabelModel): void {
        emit("label", l)
    },
    person: function (person: PersonRmodel, position: number | null): void {
        emit("person", person, position)
    },
    stop: function (...args:any[]): void {

        emit('stop',...args)
    },
    command: function (value: string, ticket: TicketRmodel): void {
        emit("command", value, ticket)
    }
}


const input = ref<HTMLInputElement | null>(null)


const { mode, blockers, block_impersonal_ui, ticket, h, ui, personTags, cardClass } = uiController(props, triggers, input)

const x =
{
    click: function click(event: PointerEvent) {

        console.log(event)

        const strip = event.target as HTMLElement

        const level = strip.offsetTop

        let t = item(props)

        h.click(t, level)

        //if (t) emit("click", t, level)
    }

}





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: _unref(ticket).n.toString(),
    class: _normalizeClass([_unref(cardClass), "strip"]),
    draggable: _unref(mode).level >= _unref(TicketAccessLevel).Full,
    onDragstart: _cache[24] || (_cache[24] = ($event: any) => (_unref(onTicketItemDrage)($event, props))),
    onDragend: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_unref(onTicketItemDragEnd) && _unref(onTicketItemDragEnd)(...args))),
    onDrop: _cache[26] || (_cache[26] = _withModifiers(
//@ts-ignore
(...args) => (_unref(h).drop && _unref(h).drop(...args)), ["prevent"])),
    onDragenter: _cache[27] || (_cache[27] = _withModifiers(() => {}, ["prevent"]))
  }, [
    _hoisted_2,
    _withDirectives(_createElementVNode("div", {
      onClick: _cache[13] || (_cache[13] = _withModifiers(
//@ts-ignore
(...args) => (x.click && x.click(...args)), ["prevent"])),
      onContextmenu: _cache[14] || (_cache[14] = _withModifiers(
//@ts-ignore
(...args) => (_unref(h).click_right && _unref(h).click_right(...args)), ["right","prevent"])),
      class: "strip-content"
    }, [
      _createElementVNode("div", _hoisted_3, [
        (_unref(mode).level >= _unref(TicketAccessLevel).Normal)
          ? (_openBlock(), _createElementBlock("i", {
              key: 0,
              class: "bi-check-lg",
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_unref(h).check && _unref(h).check(...args)), ["stop"]))
            }))
          : _createCommentVNode("", true),
        (_unref(mode).level >= _unref(TicketAccessLevel).Full)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_ctx.circledX === true)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (_unref(ticket).isArchieved())
                      ? (_openBlock(), _createElementBlock("i", {
                          key: 0,
                          class: "bi-x-lg right",
                          onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_unref(h).cross && _unref(h).cross(...args)), ["prevent"]))
                        }))
                      : (_openBlock(), _createElementBlock("i", {
                          key: 1,
                          class: "bi-x-circle right",
                          onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_unref(h).cross && _unref(h).cross(...args)), ["prevent"]))
                        }))
                  ], 64))
                : (_openBlock(), _createElementBlock("i", {
                    key: 1,
                    class: "bi-x-lg right",
                    onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_unref(h).cross && _unref(h).cross(...args)), ["prevent"]))
                  }))
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _withDirectives(_createElementVNode("input", {
        ref_key: "input",
        ref: input,
        type: "text",
        value: _unref(ticket).name,
        onKeyup: [
          _cache[4] || (_cache[4] = _withKeys(($event: any) => (_unref(mode).editing = false), ["esc"])),
          _cache[5] || (_cache[5] = _withKeys(
//@ts-ignore
(...args) => (_unref(h).name_submit && _unref(h).name_submit(...args)), ["enter"]))
        ],
        onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"])),
        onFocusout: _cache[7] || (_cache[7] = ($event: any) => (_unref(mode).editing = false))
      }, null, 40, _hoisted_4), [
        [_vShow, _unref(mode).editing]
      ]),
      (!_unref(mode).editing)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("span", _hoisted_5, [
              _createElementVNode("strong", {
                class: "clickable",
                onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_unref(clipboardTicketTitle)(_unref(ticket))), ["stop"]))
              }, "#" + _toDisplayString(_unref(ticket).n.toString()), 1)
            ]),
            (props.todo?.isDerivative())
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode("' "),
                  _createElementVNode("span", _hoisted_6, _toDisplayString(props.todo?.derivativePerson()!.name), 1)
                ], 64))
              : _createCommentVNode("", true),
            _createElementVNode("span", {
              onClick: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => (_unref(ui).edit && _unref(ui).edit(...args)), ["stop"]))
            }, _toDisplayString(_unref(ticket).name), 1),
            (_unref(ticket).name.length == 0)
              ? (_openBlock(), _createElementBlock("i", {
                  key: 1,
                  class: "bi-pen",
                  onClick: _cache[10] || (_cache[10] = _withModifiers(
//@ts-ignore
(...args) => (_unref(ui).edit && _unref(ui).edit(...args)), ["stop"]))
                }))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true),
      (_unref(ticket).file != null)
        ? (_openBlock(), _createElementBlock("span", {
            key: 1,
            class: "strip-attachment bi-paperclip",
            onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_unref(downloadTicketFile)(_unref(ticket), _unref(context))), ["stop"]))
          }))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ticket).labels, (l) => {
        return (_openBlock(), _createElementBlock("span", {
          onClick: ($event: any) => (_unref(h).tag_label(l)),
          class: "mn-tag tag-label",
          key: l.name
        }, _toDisplayString(l.name), 9, _hoisted_7))
      }), 128)),
      (_unref(block_impersonal_ui) != null)
        ? (_openBlock(), _createElementBlock("span", {
            key: 2,
            onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_unref(h).block(_unref(block_impersonal_ui))), ["stop"])),
            class: "mn-tag tag-person waiting clickable"
          }, [
            _createTextVNode("  "),
            _hoisted_8,
            _createTextVNode("  ")
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(blockers), (b) => {
        return (_openBlock(), _createElementBlock("span", {
          class: "mn-tag tag-person waiting clickable",
          key: b.person!.nid.toString(),
          onClick: _withModifiers(($event: any) => (_unref(h).block(b)), ["stop"])
        }, _toDisplayString(b.person!.name), 9, _hoisted_9))
      }), 128)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(personTags), (t) => {
        return (_openBlock(), _createElementBlock("span", {
          onClick: _withModifiers(($event: any) => (_unref(h).person_label(t)), ["stop"]),
          class: _normalizeClass(["mn-tag tag-person clickable", _unref(taskStatusCss)(t)]),
          key: t.person.name
        }, _toDisplayString(t.person.name), 11, _hoisted_10))
      }), 128))
    ], 544), [
      [_vShow, _unref(mode).menu == 0]
    ]),
    _withDirectives(_createElementVNode("div", {
      class: "strip-content",
      onClick: _cache[15] || (_cache[15] = _withModifiers(
//@ts-ignore
(...args) => (_unref(ui).personMenuReset && _unref(ui).personMenuReset(...args)), ["stop"])),
      onContextmenu: _cache[16] || (_cache[16] = _withModifiers(
//@ts-ignore
(...args) => (_unref(ui).personMenuReset && _unref(ui).personMenuReset(...args)), ["right","prevent"]))
    }, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("span", null, _toDisplayString(_unref(ticket).name), 1)
      ]),
      _createElementVNode("div", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ticket).workspace.persons(), (p, i) => {
          return (_openBlock(), _createElementBlock("span", {
            class: "clickable card-submenu-item",
            onClick: _withModifiers(($event: any) => (_unref(ui).personMenuSet(p)), ["stop"]),
            key: p.name
          }, [
            (i != 0)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode("•")
                ], 64))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(p.name), 1)
          ], 8, _hoisted_12))
        }), 128))
      ]),
      _createVNode(TicketTimingComponent, {
        style: {"background-color":"WhiteSmoke"},
        ticket: _unref(ticket),
        todo: _ctx.todo,
        efforts: _ctx.efforts
      }, null, 8, ["ticket", "todo", "efforts"])
    ], 544), [
      [_vShow, _unref(mode).menu == 1]
    ]),
    _withDirectives(_createElementVNode("div", {
      class: "strip-content",
      onClick: _cache[22] || (_cache[22] = _withModifiers(
//@ts-ignore
(...args) => (_unref(ui).personMenuReset && _unref(ui).personMenuReset(...args)), ["stop"])),
      onContextmenu: _cache[23] || (_cache[23] = _withModifiers(
//@ts-ignore
(...args) => (_unref(ui).personMenuReset && _unref(ui).personMenuReset(...args)), ["right","prevent"]))
    }, [
      _createElementVNode("div", null, [
        _createElementVNode("span", {
          class: "clickable card-submenu-item",
          onClick: _cache[17] || (_cache[17] = _withModifiers(($event: any) => (_unref(h).person(_unref(mode).menu_person!, 0)), ["stop"]))
        }, "Now"),
        _createTextVNode(" • "),
        _createElementVNode("span", {
          class: "clickable card-submenu-item",
          onClick: _cache[18] || (_cache[18] = _withModifiers(($event: any) => (_unref(h).person(_unref(mode).menu_person!, 1)), ["stop"]))
        }, "Next"),
        _createTextVNode(" • "),
        _createElementVNode("span", {
          class: "clickable card-submenu-item",
          onClick: _cache[19] || (_cache[19] = _withModifiers(($event: any) => (_unref(h).person(_unref(mode).menu_person!, 2)), ["stop"]))
        }, "Soon"),
        _createTextVNode(" • "),
        _createElementVNode("span", {
          class: "clickable card-submenu-item",
          onClick: _cache[20] || (_cache[20] = _withModifiers(($event: any) => (_unref(h).person(_unref(mode).menu_person!, -1)), ["stop"]))
        }, "Last"),
        _createTextVNode(" • "),
        _createElementVNode("span", {
          class: "clickable card-submenu-item",
          onClick: _cache[21] || (_cache[21] = _withModifiers(($event: any) => (_unref(h).person(_unref(mode).menu_person!, -2)), ["stop"]))
        }, "Someday")
      ])
    ], 544), [
      [_vShow, _unref(mode).menu == 2]
    ])
  ], 42, _hoisted_1))
}
}

})